import React from "react";
import bountyPlayWaves from "../../assets/bountyPlayWaves.png";
import bountyGroupPhoto from "../../assets/bountyGroupPhoto.png";
import { StashContent, Submission } from "./data";
import { NavLink } from "react-router-dom";
import Sidebar from "../../common/Sidebar2nd/Sidebar";
import { StateContext } from "../../store/StateProvider";
import "./Activity2.css";
import Modals from "../../common/Popup/Test/Modal";
const Index = () => {
  const [Show, setShow] = React.useState(false);

  const [state, dispatch] = StateContext();
  // model
  const ConnectWallet = (e) => {
    e.preventDefault();
    setShow(true);
  };
  return (
    <>
      <Modals Show={Show} setshow={setShow} />
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          {/* <!-- Creator-1 --> */}
          <div className="col-11 TableMax-width mx-auto py-md-5 marginTop10">
            <div className="row">
              <div className="col-md-12 mt-5">
                {/* <button onClick={ConnectWallet}>Helo</button> */}
                {/* <!-- Tabs --> */}

                <div className="MixActivityWrapper">
                  <ul className="mb-3 py-4 MixActivity_Link">
                    <ul
                      className="MixActivity_Creator nav nav-pills my-1"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="active"
                          id="pills-Submissions-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-Submissions"
                          type="button"
                          role="tab"
                          aria-controls="pills-Submissions"
                          aria-selected="true"
                        >
                          Submissions from my Stash
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className=""
                          id="pills-Bounties-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-Bounties"
                          type="button"
                          role="tab"
                          aria-controls="pills-Bounties"
                          aria-selected="true"
                        >
                          Open Bounties
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className=""
                          id="pills-SubmissionBounties-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-SubmissionBounties"
                          type="button"
                          role="tab"
                          aria-controls="pills-SubmissionBounties"
                          aria-selected="true"
                        >
                          My Submission Bounties
                        </button>
                      </li>
                    </ul>
                  </ul>
                  <div
                    className="tab-content MixActivity_Content"
                    id="pills-tabContent"
                  >
                    {/* <!-- 1 Tabs --> */}
                    <div
                      className="tab-pane fade show active"
                      id="pills-Submissions"
                      role="tabpanel"
                      aria-labelledby="pills-Submissions-tab"
                    >
                      {/* <!-- Table Header --> */}
                      <div className="MixActivityTH">
                        <div className="row row-cols-8 mx-0">
                          <div className="col-3">
                            <span className="">Stash Name</span>
                          </div>
                          <div className="col">
                            <span>NFT Editions Sold</span>
                          </div>
                          <div className="col">
                            <span>Total Sales</span>
                          </div>
                          <div className="col-3">
                            <span># of Submissions for wavpool</span>
                          </div>
                          <div className="col-2">
                            <span># of Current Bounties</span>
                          </div>
                          <div className="col-1">
                            <span>Options</span>
                          </div>
                        </div>
                      </div>
                      {/* <!-- Table Content --> */}
                      {StashContent.map((item, index) => {
                        const SaleImg = require(`../../assets/${item.StashImg}`);
                        const Preview = require(`../../assets/${item.SubData.Preview}`);
                        const Creators = require(`../../assets/${item.SubData.Creators}`);
                        const pancha = require(`../../assets/${item.SubData.Props}`);
                        return (
                          <>
                            <div
                              key={index}
                              className="MixActivityTC"
                              id="myGroup"
                            >
                              <span
                                className="me-3 TCDropDownIcon"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapseExample${index}`}
                                data-parent="#myGroup"
                              >
                                <i
                                  className="fa fa-angle-down"
                                  aria-hidden="true"
                                ></i>
                              </span>
                              <div className="row row-cols-7 mx-0">
                                <div className="col-3">
                                  <img
                                    src={SaleImg}
                                    className="img-fluid me-3 ms-4"
                                    alt=""
                                  />
                                  <p className="mb-0 d-flex flex-column">
                                    <span className="Oliviatxt1">
                                      {item.StashFirstName}
                                    </span>
                                    <span className="Oliviatxt2">
                                      {item.StashEmail}
                                    </span>
                                  </p>
                                </div>
                                <div className="col">
                                  <span>{item.NFTEdition}</span>
                                </div>
                                <div className="col">
                                  <span>{item.TotalSales}</span>
                                </div>
                                <div className="col-3">
                                  <span>{item.Submissions}</span>
                                </div>
                                <div className="col-2">
                                  <span>{item.CurrentBounties}</span>
                                </div>
                                <div className="col-1">
                                  <span className="me-4 DeleteIcon">
                                    <NavLink to={``}>
                                      <i
                                        className="fa fa-trash-o"
                                        aria-hidden="true"
                                      ></i>
                                    </NavLink>
                                  </span>
                                  <span className="EditIcon">
                                    <NavLink to={``}>
                                      <i
                                        className="fa fa-pencil"
                                        aria-hidden="true"
                                      ></i>
                                    </NavLink>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div
                              className="collapse"
                              id={`collapseExample${index}`}
                            >
                              <div className="TableSubHeader">
                                <div className="MixActivityTSubH">
                                  <div className="row row-cols-9 mx-0">
                                    <div className="col-2">
                                      <span className="ps-2">
                                        Submission Name
                                      </span>
                                    </div>
                                    <div className="col">
                                      <span>Preview</span>
                                    </div>
                                    <div className="col">
                                      <span>Creators</span>
                                    </div>
                                    <div className="col-2">
                                      <span>Open Bounty Tags</span>
                                    </div>
                                    <div className="col">
                                      <span>Wavpool #</span>
                                    </div>
                                    <div className="col-1">
                                      <span>Props</span>
                                    </div>
                                    <div className="col">
                                      <span>Date & Time</span>
                                    </div>
                                    <div className="col-2">
                                      <span className="ms-3">
                                        Enter Collab Hub
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="MixActivityTSubRow">
                                  <div className="row row-cols-8 mx-0">
                                    <div className="col-2">
                                      <span className="Nightlife ps-3">
                                        {item.SubData.SubmissionName}{" "}
                                      </span>
                                    </div>
                                    <div className="col">
                                      <span>
                                        <NavLink to={``}>
                                          <img
                                            src={Preview}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </NavLink>
                                      </span>
                                    </div>
                                    <div className="col">
                                      <span>
                                        <img
                                          src={Creators}
                                          className="img-fluid ms-2"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                    <div className="col-2">
                                      <span className="micWrapper">
                                        {item.SubData.Open.map((ele, list) => {
                                          const eleImg = require(`../../assets/${ele}`);
                                          return (
                                            <NavLink to="">
                                              <img
                                                key={list}
                                                src={eleImg}
                                                className="img-fluid"
                                                alt=""
                                              />
                                            </NavLink>
                                          );
                                        })}
                                      </span>
                                    </div>
                                    <div className="col">
                                      <span className="ms-4">
                                        {item.SubData.Wavpool}
                                      </span>
                                    </div>

                                    <div className="col-1">
                                      <img
                                        src={pancha}
                                        className="img-fluid ms-4"
                                        alt=""
                                      />
                                    </div>
                                    <div className="col">
                                      <span className="ms-4">
                                        {item.SubData.Date}
                                      </span>
                                    </div>
                                    <div className="col-2 justify-content-center">
                                      <span className="SignIcon">
                                        <NavLink to="">
                                          <i
                                            className="fa fa-sign-in"
                                            aria-hidden="true"
                                          ></i>
                                        </NavLink>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                      {/* <!-- Table Footer --> */}
                      <div className="MixActivityTF">
                        <div className="row mx-0 justify-content-between">
                          <div className="col-3">
                            <button className="btn Btn_Previous">
                              Previous
                            </button>
                          </div>
                          <div className="col-3 d-flex justify-content-center">
                            <span className="Page_txt">Page 1 of 10</span>
                          </div>
                          <div className="col-3 d-flex justify-content-end">
                            <button className="btn Btn_Previous">Next</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!-- 2 Tabs --> */}
                    <div
                      className="tab-pane fade"
                      id="pills-Bounties"
                      role="tabpanel"
                      aria-labelledby="pills-Bounties-tab"
                    >
                      <div className="row justify-content-between mx-0">
                        <div className="col-12 text-center px-0">
                          <div className="bountiesNightLifeBox mx-auto mx-md-0 mb-5 mt-4">
                            <h4 className="bountiesNightLifehead mt-4">
                              Night Life
                            </h4>
                            <h5 className="bountiesNightLifehead2">
                              Stash Name
                            </h5>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-3 mb-5 mx-auto mx-md-0 border bountiesMaxWidth">
                          <NavLink to={`/creator/Submission`} className="txts">
                            <h4 className="bountyBoxHead">OPEN</h4>
                            {/* <!-- 1 --> */}
                            <div className="bountiesCard">
                              <NavLink to="">
                                <img
                                  className="img-fluid me-4"
                                  src={state.items.bountyPlayBtn}
                                  alt=""
                                />
                              </NavLink>
                              <NavLink to="">
                                <img
                                  className="img-fluid"
                                  src={bountyPlayWaves}
                                  alt=""
                                />
                              </NavLink>
                              <div className="my-3">
                                <img
                                  className="img-fluid"
                                  src={bountyGroupPhoto}
                                  alt=""
                                />
                              </div>
                              <div className="mb-3 mt-1">
                                <span className="bountyuBoxSubBox">NFT</span>
                                <span className="bountyuBoxSubBox">Bounty</span>
                              </div>
                              <p className="bountyBoxId">
                                <span>Txn hash: </span> 0x34T..4U
                              </p>
                              <div className="d-flex justify-content-between">
                                <span className="bountyuBoxDate">10/12/22</span>
                                <span className="bountyuBoxDate">09:40pm</span>
                              </div>
                            </div>

                            {/* <!-- 1 --> */}
                            {/* <!-- 2 --> */}
                            <div className="bountiesCard">
                              <NavLink to="">
                                <img
                                  className="img-fluid me-4"
                                  src={state.items.bountyPlayBtn}
                                  alt=""
                                />
                              </NavLink>
                              <NavLink to="">
                                <img
                                  className="img-fluid"
                                  src={bountyPlayWaves}
                                  alt=""
                                />
                              </NavLink>
                              <div className="my-3">
                                <img
                                  className="img-fluid"
                                  src={bountyGroupPhoto}
                                  alt=""
                                />
                              </div>
                              <div className="mb-3 mt-1">
                                <span className="bountyuBoxSubBox">NFT</span>
                                <span className="bountyuBoxSubBox">Bounty</span>
                              </div>
                              <p className="bountyBoxId">
                                <span>Txn hash: </span> 0x34T..4U
                              </p>
                              <div className="d-flex justify-content-between">
                                <span className="bountyuBoxDate">10/12/22</span>
                                <span className="bountyuBoxDate">09:40pm</span>
                              </div>
                            </div>
                            {/* <!-- 2 --> */}
                            {/* <!-- 3 --> */}
                            <div className="bountiesCard">
                              <NavLink to="">
                                <img
                                  className="img-fluid me-4"
                                  src={state.items.bountyPlayBtn}
                                  alt=""
                                />
                              </NavLink>
                              <NavLink to="">
                                <img
                                  className="img-fluid"
                                  src={bountyPlayWaves}
                                  alt=""
                                />
                              </NavLink>
                              <div className="my-3">
                                <img
                                  className="img-fluid"
                                  src={bountyGroupPhoto}
                                  alt=""
                                />
                              </div>
                              <div className="mb-3 mt-1">
                                <span className="bountyuBoxSubBox">NFT</span>
                                <span className="bountyuBoxSubBox">Bounty</span>
                              </div>
                              <p className="bountyBoxId">
                                <span>Txn hash: </span> 0x34T..4U
                              </p>
                              <div className="d-flex justify-content-between">
                                <span className="bountyuBoxDate">10/12/22</span>
                                <span className="bountyuBoxDate">09:40pm</span>
                              </div>
                            </div>
                          </NavLink>
                          {/* <!-- 3 --> */}
                        </div>
                        <div className="col-md-6 col-lg-3 mb-5 mx-auto mx-md-0 border bountiesMaxWidth">
                          <NavLink to={`/creator/Submission`} className="txts">
                            <h4 className="bountyBoxHead2">Accepted</h4>
                            <div className="bountiesCard">
                              <NavLink to="">
                                <img
                                  className="img-fluid me-4"
                                  src={state.items.bountyPlayBtn}
                                  alt=""
                                />
                              </NavLink>
                              <NavLink to="">
                                <img
                                  className="img-fluid"
                                  src={bountyPlayWaves}
                                  alt=""
                                />
                              </NavLink>
                              <div className="my-3">
                                <img
                                  className="img-fluid"
                                  src={bountyGroupPhoto}
                                  alt=""
                                />
                              </div>
                              <div className="mb-3 mt-1">
                                <span className="bountyuBoxSubBox">NFT</span>
                                <span className="bountyuBoxSubBox">Bounty</span>
                              </div>
                              <p className="bountyBoxId">
                                <span>Txn hash: </span> 0x34T..4U
                              </p>
                              <div className="d-flex justify-content-between">
                                <span className="bountyuBoxDate">10/12/22</span>
                                <span className="bountyuBoxDate">09:40pm</span>
                              </div>
                            </div>
                          </NavLink>
                        </div>
                        <div className="col-md-6 col-lg-3 mb-5 mx-auto mx-md-0 border bountiesMaxWidth">
                          <NavLink to={`/creator/Submission`} className="txts">
                            <h4 className="bountyBoxHead2">Declined</h4>
                            <div className="bountiesCard">
                              <NavLink to="">
                                <img
                                  className="img-fluid me-4"
                                  src={state.items.bountyPlayBtn}
                                  alt=""
                                />
                              </NavLink>
                              <NavLink to="">
                                <img
                                  className="img-fluid"
                                  src={bountyPlayWaves}
                                  alt=""
                                />
                              </NavLink>
                              <div className="my-3">
                                <img
                                  className="img-fluid"
                                  src={bountyGroupPhoto}
                                  alt=""
                                />
                              </div>
                              <div className="mb-3 mt-1">
                                <span className="bountyuBoxSubBox">NFT</span>
                                <span className="bountyuBoxSubBox">Bounty</span>
                              </div>
                              <p className="bountyBoxId">
                                <span>Txn hash: </span> 0x34T..4U
                              </p>
                              <div className="d-flex justify-content-between">
                                <span className="bountyuBoxDate">10/12/22</span>
                                <span className="bountyuBoxDate">09:40pm</span>
                              </div>
                            </div>
                          </NavLink>
                        </div>
                        <div className="col-md-6 col-lg-3 mb-5 mx-auto mx-md-0 border bountiesMaxWidth">
                          <NavLink to={`/creator/Submission`} className="txts">
                            <h4 className="bountyBoxHead2">Considering</h4>
                            <div className="bountiesCard">
                              <NavLink to="">
                                <img
                                  className="img-fluid me-4"
                                  src={state.items.bountyPlayBtn}
                                  alt=""
                                />
                              </NavLink>
                              <NavLink to="">
                                <img
                                  className="img-fluid"
                                  src={bountyPlayWaves}
                                  alt=""
                                />
                              </NavLink>
                              <div className="my-3">
                                <img
                                  className="img-fluid"
                                  src={bountyGroupPhoto}
                                  alt=""
                                />
                              </div>
                              <div className="mb-3 mt-1">
                                <span className="bountyuBoxSubBox">NFT</span>
                                <span className="bountyuBoxSubBox">Bounty</span>
                              </div>
                              <p className="bountyBoxId">
                                <span>Txn hash: </span> 0x34T..4U
                              </p>
                              <div className="d-flex justify-content-between">
                                <span className="bountyuBoxDate">10/12/22</span>
                                <span className="bountyuBoxDate">09:40pm</span>
                              </div>
                            </div>
                          </NavLink>
                        </div>
                      </div>
                    </div>
                    {/* <!-- 3 Tabs --> */}
                    <div
                      className="tab-pane fade"
                      id="pills-SubmissionBounties"
                      role="tabpanel"
                      aria-labelledby="pills-SubmissionBounties-tab"
                    >
                      {/* <!-- Table Header --> */}
                      <div className="AMusicTH">
                        <div className="row row-cols-8 mx-0">
                          <div className="col-2">
                            <span className="">Submission Name</span>
                          </div>
                          <div className="col-2">
                            <span>Bounties Submitted</span>
                          </div>
                          <div className="col-2">
                            <span>Preview</span>
                          </div>
                          <div className="col">
                            <span>Creators</span>
                          </div>
                          <div className="col">
                            <span>Bounties Accepted</span>
                          </div>
                          <div className="col">
                            <span>Wavpool #</span>
                          </div>
                          <div className="col">
                            <span>Txn hash</span>
                          </div>
                          <div className="col">
                            <span>Date & Time</span>
                          </div>
                        </div>
                      </div>
                      {/* <!-- Table Content --> */}
                      {Submission.map((item, index) => {
                        const Creators = require(`../../assets/${item.Creators}`);
                        return (
                          <div key={index} className="AMusicTC">
                            <div className="row row-cols-8 mx-0">
                              <div className="col-2">
                                <span className="me-3 Nightlife">
                                  Nightlife{" "}
                                </span>
                              </div>
                              <div className="col-2">
                                <span className="micWrapper">
                                  {item.BountiesImg.map((ele, list) => {
                                    const ElementImg = require(`../../assets/${ele}`);
                                    return (
                                      <img
                                        key={list}
                                        src={ElementImg}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    );
                                  })}
                                </span>
                              </div>
                              <div className="col-2">
                                <span>
                                  <NavLink to="">
                                    <img
                                      src={state.items.bountyPlayBtn}
                                      alt=""
                                    />
                                  </NavLink>
                                  <NavLink to="">
                                    <img
                                      src={bountyPlayWaves}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </NavLink>
                                </span>
                              </div>
                              <div className="col">
                                <span>
                                  <img
                                    src={Creators}
                                    className="img-fluid"
                                    alt=""
                                  />
                                </span>
                              </div>
                              <div className="col">
                                <input
                                  type="checkbox"
                                  className="form-check-input AMusicCheckBox ms-3"
                                  id="exampleCheck1"
                                />
                              </div>
                              <div className="col">
                                <span>{item.Wavpool}</span>
                              </div>
                              <div className="col">
                                <span className="address">{item.TxnHash}</span>
                              </div>
                              <div className="col">
                                <span className="ms-4">{item.Date}</span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {/* <!-- Table Footer --> */}
                      <div className="AMusicTF">
                        <div className="row mx-0 justify-content-between">
                          <div className="col-3">
                            <button className="btn Btn_Previous">
                              Previous
                            </button>
                          </div>
                          <div className="col-3 d-flex justify-content-center">
                            <span className="Page_txt">Page 1 of 10</span>
                          </div>
                          <div className="col-3 d-flex justify-content-end">
                            <button className="btn Btn_Previous">Next</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!--ENd Tabs --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
